module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.type === 'textarea' ? 'ts-textarea' : 'ts-input', {
      'is-disabled': _vm.disabled
    }],
    style: ({
      'width': _vm.width
    })
  }, [(_vm.type !== 'textarea') ? _c('input', {
    ref: "input",
    staticClass: "ts-input--inner",
    class: {
      'is-validateEvent': _vm.validateEvent, 'is-small': _vm.size === 'small'
    },
    attrs: {
      "type": _vm.inputType,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "maxlength": _vm.maxlength,
      "minlength": _vm.minlength,
      "autocomplete": _vm.autoComplete,
      "autofocus": _vm.autofocus,
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('div', {
    staticClass: "ts-input--append"
  }, [_vm._t("append")], 2) : _vm._e(), _vm._v(" "), (_vm.type === 'textarea') ? _c('textarea', {
    ref: "textarea",
    staticClass: "ts-textarea--inner",
    class: {
      'is-validateEvent': _vm.validateEvent
    },
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "rows": _vm.rows,
      "autofocus": _vm.autofocus,
      "maxlength": _vm.maxlength,
      "minlength": _vm.minlength
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-25aaa3ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsInput.vue
// module id = 805
// module chunks = 39